import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide02UsedToBeObvious.copy'

const ease = [0.16, 1, 0.3, 1] as const
const transitionBase = { duration: 0.45, ease }
const animationProps = { initial: { opacity: 0, y: 12 }, animate: { opacity: 1, y: 0 } }

export default function Slide02UsedToBeObvious(_props: SlideProps) {
  const c = useSlideCopy(copy)

  return (
    <section className="text-slate-900 min-h-[70vh] w-full flex flex-col justify-center">
      <motion.div
        {...animationProps}
        transition={{ ...transitionBase, delay: 0 }}
        className="mb-5 max-w-2xl text-center mx-auto"
      >
        <h2 className="text-5xl sm:text-6xl font-semibold text-slate-900 tracking-tight whitespace-pre-line leading-[1.1] text-center">
          {c.title}
        </h2>
      </motion.div>

      <motion.div
        {...animationProps}
        transition={{ ...transitionBase, delay: 0.1 }}
        className="text-xl sm:text-2xl mb-10 leading-relaxed text-slate-600 max-w-2xl text-center mx-auto"
      >
        {c.body}
      </motion.div>
    </section>
  )
}
